import { DialogComponent } from '@theme/dialog';

/**
 * A custom element that manages a menu drawer.
 *
 * @extends {DialogComponent}
 */
class MenuDrawerComponent extends DialogComponent {
  connectedCallback() {
    super.connectedCallback();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
  }

  open() {
    this.showDialog();
  }

  close() {
    this.closeDialog();
  }
}

if (!customElements.get('menu-drawer-component')) {
  customElements.define('menu-drawer-component', MenuDrawerComponent);
}